(function () {
  "use strict";

  var toggle = document.querySelector("[data-menu-toggle]");
  var nav = document.querySelector("[data-mobile-nav]");
  if (toggle && nav) {
    toggle.addEventListener("click", function () {
      var open = nav.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
    nav.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function () {
        nav.classList.remove("is-open");
        toggle.setAttribute("aria-expanded", "false");
      });
    });
  }

  var storeForm = document.querySelector("[data-store-form]");
  if (storeForm) {
    storeForm.addEventListener("submit", function (event) {
      event.preventDefault();
      var input = storeForm.querySelector("input");
      var status = storeForm.querySelector("[data-store-result]");
      var area = input && input.value.trim();
      if (status) {
        status.textContent = area
          ? "Not in stores near " + area + " yet — but you can order online."
          : "Not in stores near you yet — but you can order online.";
      }
    });
  }

  document.querySelectorAll("[data-rail]").forEach(function (rail) {
    var id = rail.getAttribute("data-rail");
    document.querySelectorAll("[data-rail-control='" + id + "']").forEach(function (button) {
      button.addEventListener("click", function () {
        var direction = Number(button.getAttribute("data-direction")) || 1;
        rail.scrollBy({ left: rail.clientWidth * .82 * direction, behavior: "smooth" });
      });
    });
  });

  var year = document.querySelector("[data-year]");
  if (year) year.textContent = String(new Date().getFullYear());
})();
